import "./Loader.scss";

const Loader = ({ isActive, text }) => {
  return (
    <>
      {isActive && (
        <div
          className={`loader-overlay ${text ? "with-text" : ""}`}
          style={{ zIndex: 9999 }}
        >
          <div className="feather icon-refresh-cw icon-spin font-large-2 text-white" />
          {text && (
            <p className="text-white font-weight-bold font-medium-3 mt-1 mb-0">
              {text}
            </p>
          )}
        </div>
      )}
    </>
  );
};

export default Loader;
